const selectors = {
  block: "[data-overview]",
  filterForm: "[data-overview-filters]",
  filter: "[data-overview-filter]",
};

const initBlock = (block) => {
  const searchParams = new URLSearchParams(window.location.search);
  const queryCategory = searchParams.getAll("category");

  const filterForm = block.querySelector(selectors.filterForm);
  const filters = block.querySelectorAll(selectors.filter);

  filters?.forEach((filter) => {
    filter.checked = queryCategory.includes(filter.value);

    filter.addEventListener("click", () => {
      filterForm.submit();
    });
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
